<template>
  <div class="comparison-map">
    <div class="svg-container">
      <st-get-svg class="map-2020"
        :style="{opacity: 1 - t, zIndex: t < 0.5 ? 1 : 0, transform}"
        root-folder="boundaries/comparison/2020"
        :platform="platform"
        @onGetSvg="onMount2020">
      </st-get-svg>
      <st-get-svg class="map-2015"
        :style="{opacity: t, zIndex: t >= 0.5 ? 1 : 0, transform}"
        root-folder="boundaries/comparison/2015"
        :platform="platform"
        @onGetSvg="onMount2015">
      </st-get-svg>
      <div class="interaction" ref="zoom"></div>
    </div>
    <div class="control">
      <label>2020 <span>constituency</span></label>
      <input type="range" v-model="t" min="0" max="1" step="0.01">
      <label>2015 <span>constituency</span></label>
    </div>
    <st-get-svg class="legend"
    @onGetSvg="onLegendSvgReady"
      :style="{opacity: 0.9, zIndex: 1}"
      root-folder="boundaries/comparison-legend"
      platform="desktop">
    </st-get-svg>
    <zoom-note :iszoomed="z.k > 1" />
  </div>
</template>

<script>
import * as d3 from 'd3-selection'
import {zoom} from 'd3-zoom'
import StGetSvg from '../SvgFolder/StGetSvg'
import ZoomNote from '../ZoomNote.vue'

export default {
  components: {
    StGetSvg,
    ZoomNote
  },
  props: ['attributes'],
  data () {
    return {
      t: 0,
      z: {
        k: 1,
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    platform () {
      return this.$window.innerWidth < 768 ? 'mobile' : 'desktop'
    },
    transform () {
      const {z} = this
      return `translate(${z.x}px, ${z.y}px) scale(${z.k})`
    }
  },
  methods: {
    onLegendSvgReady ($svg) {
      let $sixMember = document.querySelector('#sixMember')
      $sixMember.style.opacity = 0
      this.$watch(vm => [vm.t, vm.z.k, vm.platform], ([t, k, platform]) => {
        if ($sixMember) $sixMember.style.opacity = t
      })
    },
    onMount2020 ($svg) {
      const $labels = $svg.getElementById('labels')
      const $initials = $svg.getElementById('initials')
      
      // let $sixMemberRect = document.querySelector('#sixMemberRect')
      // $sixMember.style.opacity = 0
      this.$watch(vm => [vm.t, vm.z.k, vm.platform], ([t, k, platform]) => {
        const opacity = Math.min(Math.max((1 - t) * 1 + t * -1.5, 0), 1)
        let $sixMember = document.querySelector('#sixMember')
        // let $sixMemberRect = document.querySelector('#sixMemberRect')
        // if ($sixMember) $sixMember.style.opacity = t
        // if ($sixMemberRect) $sixMemberRect.style.opacity = t * 0.8
        // console.log(t)
        if (platform === 'desktop') {
          if ($labels) $labels.style.opacity = opacity
        } else if (k >= 1.5) {
          if ($labels) $labels.style.opacity = opacity
          if ($initials) $initials.style.opacity = 0
        } else {
          if ($labels) $labels.style.opacity = 0
          if ($initials) $initials.style.opacity = opacity
        }
      }, {immediate: true})
      this.mountInteraction()
    },
    onMount2015 ($svg) {
      const $labels = $svg.getElementById('labels')
      const $initials = $svg.getElementById('initials')
      this.$watch(vm => [vm.t, vm.z.k, vm.platform], ([t, k, platform]) => {
        const opacity = Math.min(Math.max((1 - t) * -1.5 + t * 1, 0), 1)
        if (platform === 'desktop') {
          if ($labels) $labels.style.opacity = opacity
        } else if (k >= 1.5) {
          if ($labels) $labels.style.opacity = opacity
          if ($initials) $initials.style.opacity = 0
        } else {
          if ($labels) $labels.style.opacity = 0
          if ($initials) $initials.style.opacity = opacity
        }
      }, {immediate: true})
    },
    allowScroll (el) {
      var originY = 0
      var touches = 0
      el.addEventListener('touchstart', (e) => {
        touches = e.touches.length
        if (e.touches.length < 2) {
          originY = e.changedTouches[0].pageY
        }
      })
      el.addEventListener('touchmove', (e) => {
        if (touches < 2) {
          window.scrollBy({
            top: originY - e.changedTouches[0].pageY,
            behavior: 'smooth'
          })
        }
      })
    },
    mountInteraction () {
      if (this.$window.innerWidth < 420) {
        const $zoom = this.$refs.zoom

        this.allowScroll($zoom)

        const {width, height} = $zoom.getBoundingClientRect()
        const behavior = zoom()
          .filter(() => {
            return !(d3.event.type === 'wheel') &&
                   !(d3.event.type === 'touchstart' && d3.event.touches.length < 2)
          })
          .scaleExtent([1, 3])
          .translateExtent([
            [0, 0],
            [width, height]
          ])
          .on('zoom', () => {
            this.z = d3.event.transform
          })
        d3.select($zoom).call(behavior)
      }
    }
  }
}
</script>

<style lang="scss">
.comparison-map {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  position: relative;

  .svg-container {
    position: relative;
    overflow: hidden;
  }

  .interaction {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  .map-2020 {
    width: 100%;
    transform-origin: 0 0;
  }

  .map-2015 {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    transform-origin: 0 0;
  }

  .control {
    position: absolute;
    top: 0;
    z-index: 2;

    @include breakpoint($d_small) {
      right: 0;
    }

    label {
      font-family: $font-OpenSans-Regular;
      font-size: 16px;

      & > span {
        display: none;

        @include breakpoint($d_small) {
          display: inline;
        }
      }
    }

    > * {
      vertical-align: middle;
    }

    input {
      margin: 0 5px;

      @include breakpoint($d_small) {
        margin: 0 20px;
      }
    }
  }

  .legend {
    min-width: 240px;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    font-size: 14px;

    @include breakpoint(810px) {
      top: 0;
      bottom: auto;
      right: auto;
      width: 375px;
      font-size: 16px;
    }
  }
}
</style>
